export function removeMask(value) {
    return value.replace(/[^\d]/g, '');
}
